import
  React, {
  useEffect
} from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Debounceable,
  HFillContainer,
  Text
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons,
  SearchRegEx
} from '../../../constants';

import {
  isEqual
} from 'helpers';

const Container = styled(HFillContainer)`
  width: ${props => props.width};
  height: ${props => props.height};
  padding: ${props => props.padding};
`;

const SearchBoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${props => props.inputPadding};
  border-radius: ${props => props.height};
  border: solid 0.1vh ${props => props.borderColor};
`;

const SearchField = styled.input`
  flex: 1 0 auto;
  padding-left: 2vw;
  margin-bottom: 0;
  font-size: 16px;
  color: ${props => props.color};
  border: none;
  outline: none;

  &:focus {
    border: none;
  }

  &::placeholder {
    color: ${CustomColors.Grey6};
    font-size: '16px';
  }
`;

export const SearchBar = props => {

  const [
    state,
    setState
  ] = React.useState({
    value: props.value,
    pattern: SearchRegEx,
    borderColor: props.borderColor
  });

  const handleKeyDown = (event) => {

    if (!event) {
      return;
    }

    if (isEqual(event.key, 'Enter')) {
      props.onSearchClick?.(state.value);
    }
  };

  const search = new Debounceable();

  const debounceSearch = search.debounce((
    searchText
  ) => {

    props.onSubmit?.({
      searchText: searchText
    });
  },
  props.debounceWait);

  const onSearchTextChanged = (
    e
  ) => {

    if (!e || !e.target || typeof e.target.value !== 'string' || !state.pattern?.test(e.target.value)) {
      setState(prevState => ({
        ...prevState,
        borderColor: CustomColors.Red1
      }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      borderColor: CustomColors.Grey4,
      value: e.target.value
    }));
  };

  useEffect(() => {
    debounceSearch(state.value);
    return search.clear;
  });

  useEffect(() => {

    setState(prevState => ({
      ...prevState,
      value: props.value
    }));
  }, [ props.value ]);

  return (
    <>
      <Container
        flex={props.flex}
        width={props.width}
        height={props.height}
        padding={props.padding}
        margin={props.margin}
        minHeight={props.minHeight}
        minWidth={props.minWidth}
        maxHeight={props.maxHeight}
        maxWidth={props.maxWidth}>

        <SearchBoxContainer
          inputPadding={props.inputPadding}
          borderColor={state.borderColor}
          height={props.height}>

            <ColorSvg
              src={Icons.Search}
              color={CustomColors.Black}
              height={'20px'}
              width={'20px'}
              onClick={() => props?.onSearchClick(state.value)}/>

            <SearchField
              automationId={props.automationId}
              placeholder={props.placeholder}
              padding='16px 15px'
              type={'text'}
              value={state.value}
              color={CustomColors.Grey6}
              onChange={onSearchTextChanged}
              onKeyDown={handleKeyDown}
            />

        </SearchBoxContainer>

      </Container>
      {
        state.borderColor === CustomColors.Red1 &&
        <Text
          color={CustomColors.Red1}
          padding={'5px 0 0'}
          fontSize={'12px'}>
          {'Please only enter valid characters'}
        </Text>
      }
    </>

  );
};

SearchBar.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  padding: PropTypes.string,
  borderColor: PropTypes.string,
  margin: PropTypes.string,
  minHeight: PropTypes.string,
  minWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  inputPadding: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onSubmit: PropTypes.func,
  onSearchClick: PropTypes.func,
  debounceWait: PropTypes.number
};

SearchBar.defaultProps = {
  width: '100%',
  height: '50px',
  padding: '0',
  borderColor: CustomColors.Grey4,
  margin: null,
  minHeight: null,
  minWidth: null,
  maxHeight: '50px',
  maxWidth: null,
  inputPadding: '16px 15px',
  placeholder: 'Type here to search Wikipedia',
  value: '',
  onSubmit: () => {},
  onSearchClick: () => {},
  debounceWait: 750
};
